/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_Protocol_LinksInputs */

const cs_tasks_protocol_links = /** @type {(inputs: Tasks_Protocol_LinksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odkazy k podpisu`)
};

const en_tasks_protocol_links = /** @type {(inputs: Tasks_Protocol_LinksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signing links`)
};

/**
* | output |
* | --- |
* | "Signing links" |
*
* @param {Tasks_Protocol_LinksInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const tasks_protocol_links = /** @type {((inputs?: Tasks_Protocol_LinksInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Protocol_LinksInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_protocol_links(inputs)
	return cs_tasks_protocol_links(inputs)
});